import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { IEcommerceCustomer } from '../models/ecommarce-customer.interface';

@Injectable()
export class b2bclientsService extends ApiService {

    public createB2bClient(body: IEcommerceCustomer): Observable<IEcommerceCustomer> {
        return this.requestEcommerce({
            method: 'POST',
            path: `users/create-b2b-client`,
            body,
        });
    }

    getB2bClientsAccess(companyId: number | string = '', page: number = 1, limit: number = 100, q: string = '', orderField: string = '', orderDirection = ''): Observable<any> {
        return this.requestEcommerce({
            method: 'GET',
            path: `users`,
            query: {
                q,
                companyId,
                page,
                limit,
                orderField,
                orderDirection,
            },
        });
    }

    setB2bClientsAccess(body): Observable<any> {
        return this.request({
            path: 'b2b-access',
            method: 'POST',
            body: body
        });
    }

    deleteB2bClientsAccess(id): Observable<any> {
        return this.request({
            path: `b2b-access/${id}`,
            method: 'DELETE',
        });
    }

    updateB2bClientsAccess(id, body): Observable<any> {
        return this.request({
            path: `b2b-access/${id}`,
            method: 'PUT',
            body: body
        });
    }

    updateB2bClient(body): Observable<any> {
        return this.requestEcommerce({
            path: `users/update-b2b-client`,
            method: 'PUT',
            body: body
        });
    }

    changeStatus(id:number ,status:any) {
            return this.request({
                path: `b2b-access/b2b-status/${id}`,
                method: 'PUT',
                body: status
            })
    }

    changeStatusB2BClient(id:number ,status:any) {
            return this.requestEcommerce({
                path: `users/b2b-status/${id}`,
                method: 'PUT',
                body: status
            })
    }

    getBuyers(companyId) {
        return this.requestEcommerce({
            method: 'GET',
            path: `users/buyers/${companyId}`,
        });
    }

    /**
     * Update stripe status.
     * Use for apply stripe test sendbox card for test payment on production
     * only for Empact admin
     */
    public changeStripeStatus(id: number, status: boolean): Observable<any>{
        return this.requestEcommerce({
            path: `users/stripe-status/${id}`,
            method: 'PUT',
            body: { isStripeSandbox: status },
        })
    }
}
